// extracted by mini-css-extract-plugin
export default {"error":"error-boundary_error__oPaqE"};